import { config } from '@/config';
import { CacheScrapingFile, ClearCacheFiles, Scraping, ScrapingFile } from '@/model/centralized';
import axios, { HttpStatusCode } from 'axios';
import axiosRetry from 'axios-retry';

const instance = axios.create({
	baseURL: config.centralizedHost,
	timeout: 1000 * 60 * 10 // 5 minutes
});

const retryInstance = axios.create({
	baseURL: config.centralizedHost,
	timeout: 1000 * 60 * 10 // 5 minutes
});

axiosRetry(retryInstance, {
	retries: 5,
	retryCondition(error) {
		if (error.response?.status) {
			return error.response?.status >= 500;
		}
		return false;
	}
});

export async function scraping<T>(body: Scraping) {
	const res = await instance.request<T>({
		url: '/scraping/dynamic',
		method: 'POST',
		data: body
	});
	return res.data;
}

export async function scrapingFile(body: ScrapingFile) {
	body.fetchFromServer = true;
	const res = await retryInstance.request<Blob>({
		url: '/scraping/file',
		method: 'POST',
		data: body,
		responseType: 'blob'
	});
	if (res.status === HttpStatusCode.Created && res.headers && res.headers['content-type']) {
		return { data: res.data, mimeType: res.headers['content-type'].toString() };
	}
	throw Error(res.status?.toString() || 'Something went wrong!');
}

export async function cacheFiles(body: CacheScrapingFile) {
	return await instance.request({
		url: '/scraping/file/cache',
		method: 'POST',
		data: body
	});
}

export async function clearCacheFiles(body: ClearCacheFiles) {
	return await instance.request({
		url: '/scraping/file/cache',
		method: 'DELETE',
		data: body
	});
}
